module.exports = __webpack_public_path__ + "static/media/project-buddy.31e5175c.jpg";